export default __webpack_public_path__ + "static/media/gold2.0407233b.png";